import {
  GET_USER_BY_ID,
  GET_USER_BY_ID_SUCCESS,
  GET_USER_BY_ID_FAIL,
} from "./actionTypes"

//Get User By Id
export const getUserById = id => ({
  type: GET_USER_BY_ID,
  payload: id,
})
export const getUserByIdSuccess = user => ({
  type: GET_USER_BY_ID_SUCCESS,
  payload: user,
})
export const getUserByIdFail = error => ({
  type: GET_USER_BY_ID_FAIL,
  payload: error,
})
